import type { PublicCheckoutFunnelNode } from './contract';

export const FUNNEL_ROOT_ID = 'product';

import type { BuyerPaymentMethod } from './contract';

export type FunnelDecisionStatus = 'paid' | 'reserved' | 'rejected';

export interface FunnelDecision {
  nodeId: string;
  parentNodeId: string;
  status: FunnelDecisionStatus;
  saleId?: string;
  method?: BuyerPaymentMethod;
}

function isShowable(node: PublicCheckoutFunnelNode, decisions: readonly FunnelDecision[]): boolean {
  if (decisions.some((decision) => decision.nodeId === node.id)) {
    return false;
  }
  if (decisions.some((decision) => decision.parentNodeId === node.parentId)) {
    return false;
  }
  if (node.parentId === FUNNEL_ROOT_ID) {
    return node.branch === 'accept';
  }
  const parentDecision = decisions.find((decision) => decision.nodeId === node.parentId);
  if (parentDecision === undefined) {
    return false;
  }
  return node.branch === 'accept' ? parentDecision.status === 'paid' : parentDecision.status === 'rejected';
}

export function nextFunnelNode(
  funnel: readonly PublicCheckoutFunnelNode[],
  decisions: readonly FunnelDecision[],
): PublicCheckoutFunnelNode | null {
  return funnel.find((node) => isShowable(node, decisions)) ?? null;
}

export function recordFunnelDecision(
  decisions: readonly FunnelDecision[],
  node: PublicCheckoutFunnelNode,
  status: FunnelDecisionStatus,
  details: { saleId?: string | undefined; method?: BuyerPaymentMethod | undefined } = {},
): FunnelDecision[] {
  const next = decisions.filter((decision) => decision.nodeId !== node.id);
  next.push({
    nodeId: node.id,
    parentNodeId: node.parentId,
    status,
    ...(details.saleId !== undefined ? { saleId: details.saleId } : {}),
    ...(details.method !== undefined ? { method: details.method } : {}),
  });
  return next;
}
